<div>
  <div>
    © 2024 Nuclear Waste Management Organization, powered by Eckler. All rights
    reserved.
  </div>
  <span class="noprint">
    <div><a (click)="viewActuarialAssumptions()">Actuarial Assumptions</a></div>
    <div><a (click)="viewTermsAndConditions()">Terms & Conditions</a></div>
  </span>
</div>
